import ConnectLayout from '../ConnectLayout';
import { Box, Button, Typography } from '@material-ui/core';
import lang from './LoginPage.json';
import InfoCell from './components/InfoCell/InfoCell';
import { BookOutlined, DashboardOutlined, HelpOutline } from '@material-ui/icons';
import React from 'react';
import './LoginPage.scss';
import WileyLogo from 'assets/img/connect/connect_background.png';
import useConnectAuth from '../hooks/useConnectAuth';
import links from '../links';

function ConnectLoginPage() {
  const { startConnectLogin } = useConnectAuth();

  return (
    <ConnectLayout>
      <div className="login-page__content" style={{ backgroundImage: `url(${WileyLogo})` }}>
        <Box className="login-page__welcome">
          <Typography className="login-page__welcome-title" variant="h4">
            {lang.appName}
          </Typography>

          <Typography className="login-page__welcome-subTitle" variant="body1">
            {lang.welcome}
          </Typography>

          <Box className="login-page__welcome-action">
            <Button
              className="login-page__welcome-action-button"
              data-testid="connect-dashboard-link"
              onClick={startConnectLogin}
              variant="contained"
            >
              {lang.dashboardLink}
            </Button>
          </Box>
        </Box>

        <Box className="login-page__info">
          <InfoCell
            description={lang.dashboardDescription}
            icon={<DashboardOutlined className="login-page__info-icon" />}
            links={links.dashboard}
            title={lang.dashboardTitle}
          />

          <InfoCell
            description={lang.authorResourcesDescription}
            icon={<BookOutlined className="login-page__info-icon" />}
            links={links.authorResources}
            title={lang.authorResourcesTitle}
          />

          <InfoCell
            description={lang.supportDescription}
            icon={<HelpOutline className="login-page__info-icon" />}
            title={lang.supportTitle}
          />
        </Box>
      </div>
    </ConnectLayout>
  );
}

export default ConnectLoginPage;
